<template>
  <li class="list_card new" @click="goView(item.id)">
    <!--확인 안 한 견적이 있을 시 new추가-->
    <div class="top">
      <p class="date">
        {{ getCreateAt(item.requestedAt) }}<span>모집마감</span>
      </p>
      <div class="num" v-if="item.estimateStores.length > 0">
        <p>총 {{ item.estimateStores.length }}개의 견적</p>
        <div class="dot" v-if="item.unreadCnt > 0"></div>
      </div>
    </div>
    <div class="btm">
      <ul class="inter_prod_list prof_phone">
        <li class="phone_product">
          <div class="left">
            <img :src="item.deviceImage" alt="" />
          </div>
          <div class="right">
            <h4>{{ item.modelName }}</h4>
            <p>{{ item.deviceColor }}</p>
          </div>
        </li>
        <li>
          <dl>
            <dt>구매대상자</dt>
            <dd v-if="item.areaName2">
              {{ item.target == 1 ? '본인' : '부모님/자녀 등' }} -
              {{ getAgeText(item.targetDetail) }}
              ({{ item.areaName1 }}, {{ item.areaName2 }})
            </dd>
            <dd v-else>
              {{ item.target == 1 ? '본인' : '부모님/자녀 등' }} -
              {{ getAgeText(item.targetDetail) }}
              ({{ item.areaName1 }})
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>현재사용폰</dt>
            <dd v-if="item.useDeviceName && item.target == 1">
              {{ item.useTelecomName }} / {{ item.useDeviceName }}
            </dd>
            <dd v-else>
              {{ item.useTelecomName }}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>변경통신사</dt>
            <dd v-if="item.joinType == 'NEW'">
              {{ item.telecomName }} (가입유형-신규)
            </dd>
            <dd v-else-if="item.joinType == 'CHANGE'">
              {{ item.telecomName }} (가입유형-기기변경)
            </dd>
            <dd v-else-if="item.joinType == 'MNP'">
              {{ item.telecomName }} (가입유형-번호이동)
            </dd>
          </dl>
        </li>
        <!-- <li v-if="item.planName">
          <dl>
            <dt>선호요금제</dt>
            <dd>{{ item.planName }}</dd>
          </dl>
        </li> -->
      </ul>
    </div>
  </li>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    item: Object,
  },
  components: {},
  data() {
    return {
      listSelectIndex: 0,
    };
  },
  async created() {},
  computed: {},
  methods: {
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yy.MM.dd');
    },
    getCreateAtDay(createAt) {
      const createdAt = new Date(createAt);

      const endDay = format(
        new Date(createdAt.setDate(createdAt.getDate() + 7)),
        'yyyy-MM-dd HH:mm:ss',
      );

      const now = new Date();
      new Date(now.setDate(now.getDate()), 'yyyy-MM-dd HH:mm:ss');

      var resdays = this.getDateDiff(now, endDay);

      // console.log('박수 : ' + resdays);
      return resdays;
    },
    goLink(link) {
      this.$router.push({ name: link });
    },
    getDateDiff(d1, d2) {
      const date1 = new Date(d1);
      const date2 = new Date(d2);

      const diffDate = date1.getTime() - date2.getTime();

      let mathVal = Math.abs(diffDate / (1000 * 60 * 60 * 24));

      // 시간으로 표시
      if (mathVal < 1) {
        return (
          Math.ceil(Math.abs(diffDate / (1000 * 60 * 60))).toString() + '시간'
        ); // 밀리세컨 * 초 * 분 * 시 = 일
      } else {
        return (
          Math.floor(Math.abs(diffDate / (1000 * 60 * 60 * 24))).toString() +
          '일'
        ); // 밀리세컨 * 초 * 분 * 시 = 일
      }
    },
    isItemCompose(item) {
      let itemCompose = '';

      if (item.itemInternet) {
        itemCompose = '[인터넷] ';
        itemCompose += item.itemInternet;
      }

      if (item.itemTv) {
        itemCompose += '<br/>';
        itemCompose += '[TV] ';
        itemCompose += item.itemTv;
      }

      return itemCompose;
    },
    listSelect(index) {
      this.listSelectIndex = index;
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '25');

      return path;
    },
    getAgeText(age) {
      if (age == 'U_12') {
        return '키즈';
      } else if (age == 'O_65') {
        return '어르신';
      } else if (age == 'O_19') {
        return '성인';
      } else if (age == 'B_35_64') {
        return '일반';
      } else if (age == 'B_19_34') {
        return '청년';
      } else if (age == 'U_18' || age == 'B_12_18') {
        return '청소년';
      }
    },
    goView(id) {
      this.$emit('goView', id, 'END');
    },
  },
};
</script>
